:host {
    display: block;

    .flex-start .counter{
        justify-content: flex-start;
    }
    .center .counter{
        justify-content: center;
    }
    .flex-end .counter{
        justify-content: flex-end;
    }
    .space-around .counter{
        justify-content: space-around;
    }
    .space-between .counter{
        justify-content: space-between;
    }
    .space-evenly .counter{
        justify-content: space-evenly;
    }
}
